import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocalizedPath } from '../../../hooks/useLocalizedPath';
import { Section, Container } from '../../ui';
import styles from './ArticleHeader.module.css';

interface ArticleHeaderProps {
  title: string;
  date: string;
  author: string;
  category: string;
  readingTime: number;
  thumbnail: string;
}

export function ArticleHeader({
  title,
  date,
  author,
  category,
  readingTime,
  thumbnail,
}: ArticleHeaderProps) {
  const { t, i18n } = useTranslation('blog');
  const { lp } = useLocalizedPath();

  const formattedDate = new Date(date).toLocaleDateString(
    i18n.language === 'fr' ? 'fr-FR' : 'en-US',
    { year: 'numeric', month: 'long', day: 'numeric' }
  );

  return (
    <>
      <Section variant="dark" className={styles.hero}>
        <Container>
          <div className={styles.inner}>
            <Link to={lp('/blog')} className={styles.backLink}>
              {t('article.backToBlog')}
            </Link>
            <span className={styles.badge}>
              {t(`categories.${category}`)}
            </span>
            <h1 className={styles.title}>{title}</h1>
            <div className={styles.meta}>
              <span>{t('article.by')} {author}</span>
              <span className={styles.separator}>·</span>
              <span>{formattedDate}</span>
              <span className={styles.separator}>·</span>
              <span>{readingTime} {t('listing.minRead')}</span>
            </div>
          </div>
        </Container>
      </Section>
      {thumbnail && (
        <div className={styles.thumbnailWrapper}>
          <Container>
            <img
              src={thumbnail}
              alt={title}
              className={styles.thumbnail}
            />
          </Container>
        </div>
      )}
    </>
  );
}
